const REDIRECT_STORAGE_KEY = "redirect";

export function saveRedirectPath(path) {
  if (!path || path === "/login") return;
  localStorage.setItem(REDIRECT_STORAGE_KEY, path);
}

export function getRedirectPath() {
  return localStorage.getItem(REDIRECT_STORAGE_KEY);
}

export function clearRedirectPath() {
  localStorage.removeItem(REDIRECT_STORAGE_KEY);
}

export function consumeRedirectPath() {
  const path = getRedirectPath();
  clearRedirectPath();
  return path;
}